<template>
    <!-- TODO da fare più bello -->
    <div>
        <div class="text-center m-5">
            <div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {}
</script>
